import { render, staticRenderFns } from "./lp-investor2.vue?vue&type=template&id=76a19a4c&scoped=true"
import script from "./lp-investor2.vue?vue&type=script&lang=js"
export * from "./lp-investor2.vue?vue&type=script&lang=js"
import style0 from "./lp-investor2.vue?vue&type=style&index=0&id=76a19a4c&prod&scoped=true&lang=css"
import style1 from "./lp-investor2.vue?vue&type=style&index=1&id=76a19a4c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a19a4c",
  null
  
)

export default component.exports